import NotificationService from "@/Services/NotificationService";
import OrdersService from "@/Services/OrdersService";
export const notificationModule = {
    namespaced : true,
    state:{
        topics:[],
        notifications :{
            currentPage : 0,
            data : [],
            hasNext:true,
        },
        notificationCount :0,
        pendingDepositOrderId: null,
        pendingDepositMessage: '',
        showDepositModal: false
    },actions:{
        SetNewBackGroundNotification({commit} , payload){
            commit('setNewNotification' , payload);
        }
        ,GetNotifications({commit} , page ){
            return NotificationService.GetNotifications(page).then(res=>{
                commit('setNotifications' , res);
                return Promise.resolve(res);
            });
        },
        UpdateSeen({commit}){
            commit("setNotificationsCount" , 0);
        },
        ResetNots({commit} ){
            commit("ResetNots");
        },
        GetNotificationCount({commit}){
            return NotificationService.GetNotificationsCount().then(res=>{
                commit('setNotificationsCount' , res);
            });
        },
        async subscribeUser({commit}){
            let topics= NotificationService.GetUserTopics();
            await NotificationService.SubscribeToUserTopics();
            commit('setUserTopics' , topics);
            return Promise.resolve();
        },

        OpenDepositModal({ commit }, { orderId }) {
            return OrdersService.GetMessageDepositFromUserWallet(orderId).then(res => {
                const message = (res && (res.successMessage || res.SuccessMessage)) ? (res.successMessage || res.SuccessMessage) : '';
                commit('setPendingDeposit', { orderId, message });
                commit('setShowDepositModal', true);
            });
        },

        ResolveDepositAndClose({ commit }, { orderId, applied }) {
            const promise = applied
                ? OrdersService.ApplyDepositFromUserWallet(orderId)
                : OrdersService.CancelDepositFromUserWallet(orderId);
            return promise.then(() => {
                commit('removeNotificationByDataId', orderId);
                commit('clearPendingDeposit');
                commit('setShowDepositModal', false);
            });
        },

        DismissDepositModal({ commit }) {
            commit('clearPendingDeposit');
            commit('setShowDepositModal', false);
        }
    }
    ,mutations: {
        setNewNotification(state , res){
            state.notificationCount++;
        },
        setNotifications(state , res){
            if(res.data && res.data.length>0){
                state.notifications.data=state.notifications.data.concat(res.data);
                state.notifications.currentPage = res.currentPage;
                state.notifications.hasNext = res.hasNext;
            }
        },
        setUserTopics(state, res){
            state.topics=res;
        },
        setNotificationsCount(state, res){
            state.notificationCount = res;
        },
        setPendingDeposit(state, { orderId, message }) {
            state.pendingDepositOrderId = orderId;
            state.pendingDepositMessage = message;
        },
        clearPendingDeposit(state) {
            state.pendingDepositOrderId = null;
            state.pendingDepositMessage = '';
        },
        setShowDepositModal(state, show) {
            state.showDepositModal = show;
        },
        removeNotificationByDataId(state, dataId) {
            state.notifications.data = (state.notifications.data || []).filter(n => n.dataId != dataId);
        },
        ResetNots(state){
            state.notifications = {
                currentPage : 0,
                data : [],
                hasNext:true,
            };
        }
    },getters:{
        getNotifications : (state)=>{
            return state.notifications?.data??[];
        },
        getNotificationCount: (state)=>{
            return state.notificationCount;
        },
        HasNext: (state)=>{
            return state.notifications&& state.notifications.hasNext;
        },
        GetPage: (state)=>{
            return state.notifications? state.notifications.currentPage: 0;
        },
        getUserTopics:(state)=>{
            return state.topics;
        },
        pendingDepositOrderId: (state) => state.pendingDepositOrderId,
        pendingDepositMessage: (state) => state.pendingDepositMessage,
        showDepositModal: (state) => state.showDepositModal
    }

}